import { apiGet, apiPost } from '../helpers/ApiHelper';

import * as notifications from './notificationActions';
import * as authentication from './authenticationActions';
import * as userTypes from './userTypesActions';

import Auth from 'j-toker';
import { browserHistory } from 'react-router';
import { updateLanguage } from 'react-localize-redux';

function saveRedirectProperty(property_id, referrer) {
  return {
    type: 'REDIRECTION::REDIRECT_TO_APPLICATION',
    property_id,
    referrer,
  };
}

export function receieveOnboardUser(onboardUser) {
  return {
    type: 'REDIRECTION::GET_ONBOARD_USER',
    onboardUser,
  };
}

export function receiveInvitationToken(invitation_token, user_type) {
  return {
    type: 'REDIRECTION::INVITATION_TOKEN',
    invitation_token,
    user_type,
  };
}

export function getOnboardUser(invitation_token, user_type) {
  return dispatch => {
    dispatch(receiveInvitationToken(invitation_token, user_type));
    return dispatch({
      type: 'FETCH_INVITATION_TOKEN',
      payload: apiGet(Auth.getApiUrl() + `/landlords/user_onboarding/${invitation_token}`)
        .done(response => {
          if (response.landlord_logo_url) {
            dispatch(userTypes.setLandlordLogo(response.landlord_logo_url));
          }
          if (response.accent_color) {
            dispatch(userTypes.setAccentColor(response.accent_color));
          }
          dispatch(receieveOnboardUser(response));
          return response;
        })
        .catch((error, textStatus) => {
          dispatch(authentication.logUserOut());
          console.error(textStatus);
          return { error };
        }),
    });
  };
}

export function postOnboardUser(invitation_token, user, onboarding_traffic_source = null) {
  let data_clone = JSON.parse(JSON.stringify(user)); // needed so it does not change redux form data

  const email = 'e';
  const sms = 's';
  if (onboarding_traffic_source && onboarding_traffic_source === email) {
    data_clone['onboarding_traffic_source'] = 'email';
  } else if (onboarding_traffic_source && onboarding_traffic_source === sms) {
    data_clone['onboarding_traffic_source'] = 'sms';
  }

  return (dispatch, getState) => {
    const { landlordId } = getState().userTypes;
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/confirm_user/${invitation_token}`, data_clone)
        .done(response => {
          if (response.two_factor_enabled) {
            onPostOnboardingTwoFactor(data_clone, dispatch);
          } else {
            onPostOnboadingSuccess(data_clone, dispatch, landlordId);
            return response;
          }
        })
        .catch((error, _textStatus) => {
          return { error: error.responseJSON };
        }),
    });
  };
}

function onPostOnboardingTwoFactor(data_clone, dispatch) {
  if (data_clone.user_type === 'Maintenance') {
    dispatch(
      userTypes.setUserAsMaintenance({
        email: data_clone.email,
        createdSuccess: true,
      })
    );
    browserHistory.push('/maintenance');
  } else if (data_clone.user_type === 'Agent') {
    dispatch(
      userTypes.setUserAsLandlord({
        email: data_clone.email,
        createdSuccess: true,
      })
    );
    browserHistory.push('/companies');
  }
}

function onPostOnboadingSuccess(data_clone, dispatch, landlord_id) {
  Auth.configDfd = null;
  let config, redirect_url, user_type_setup;
  if (data_clone.user_type === 'Maintenance') {
    user_type_setup = userTypes.setUserAsMaintenance;
    redirect_url = '/maintenance/dashboard';
    config = 'maintenance';
  } else if (data_clone.user_type === 'Agent') {
    user_type_setup = userTypes.setUserAsLandlord;
    redirect_url = '/companies/dashboard';
    config = 'landlord';
  } else if (data_clone.user_type === 'Lead') {
    user_type_setup = userTypes.setUserAsLead;
    redirect_url = `/dashboard?${browserHistory.getCurrentLocation().search}`;
    config = 'default';
  }

  Auth.emailSignIn({
    username: data_clone.email,
    password: data_clone.password,
    config: config,
    landlord_id,
  })
    .then(response => {
      if (response.data && response.data.id) {
        dispatch(updateLanguage(response.data.language_code));
        localStorage.setItem('locale', response.data.language_code);
        if (user_type_setup) {
          const params = data_clone.user_type !== 'Maintenance' ? response.data : undefined;
          dispatch(user_type_setup(params));
        }
        browserHistory.push(redirect_url);
      }
    })
    .catch(error => {
      onPostOnboardingError(error.data.errors, dispatch);
    });
}

function onPostOnboardingError(error, dispatch) {
  dispatch(notifications.showFailure(error, true));
  Auth.configDfd = null;
  dispatch(authentication.logUserOut());
  console.error(error);
}

export function redirectToApplication(property_id, referrer) {
  return dispatch => {
    return apiGet(Auth.getApiUrl() + `/landlords/properties/verify/${property_id}`)
      .done(response => {
        browserHistory.push('/apply_and_sign_up' + browserHistory.getCurrentLocation().search);
        dispatch(saveRedirectProperty(property_id, referrer));
      })
      .catch((error, textStatus) => {
        dispatch(notifications.showFailure('thatPropertyDoesNotExist'));
        browserHistory.push('/');
        console.error(textStatus);
        throw Error;
      });
  };
}
